<template>
  <div class="qr-code-generator" :key="componentKey">
    <div class="modal qr-code-generator-modal">
      <div class="modal-background" @click="closeModal"></div>
      <button class="modal-close is-large" @click="closeModal"></button>

      <div class="modal-card">
        <section class="modal-card-body">
          <br />
          <p class="error">{{ error }}</p>
          <div class="qr-code">
            <qr-canvas :options="options"></qr-canvas>
          </div>
          <!-- <br /> -->
          <div class="control has-icons-right" style="margin-top: 10px">
            <input
              class="input is-medium is-light has-text-centered has-text-link is-fullwidth"
              type="text"
              v-model="url"
            />
            <span
              v-if="url"
              class="icon is-small is-right"
              style="pointer-events: initial"
            >
              <i class="fa fa-times" @click="url = null" />
            </span>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { QRCanvas } from "qrcanvas-vue";

export default {
  name: "QRCodeGenerator",
  components: {
    QrCanvas: QRCanvas,
  },
  data() {
    return {
      componentKey: 0, // increment to reset, a hack that's not working...
      result: "",
      error: "",
      url: "https://tukapp.co/qr/a",
      logo: "/img/icons/round-180x180.png",
      // QR code generator options
      options: {
        cellSize: 8,
        correctLevel: "H",
      },
    };
  },
  watch: {
    url: function () {
      this.generateQRCode(); // when the hash prop changes, this function will be fired.
    },
  },
  created() {
    const image = new Image();
    image.src = this.logo;
    image.onload = () => {
      this.options = Object.assign({}, this.options, {
        logo: {
          image,
        },
        data: "https://tukapp.co",
      });
    };
  },
  methods: {
    generateQRCode() {
      const image = new Image();
      image.src = this.logo;
      image.onload = () => {
        this.options = Object.assign({}, this.options, {
          logo: {
            image,
          },
          data: this.url,
        });
      };
    },
    closeModal() {
      this.componentKey += 1;
      this.url = "https://tukapp.co/";
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
  },
};
</script>

<style scoped lang=scss>
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* bring your own prefixes */
}
.url {
  background-color: rgba(39, 243, 243, 0.349);
  padding: 10px;
  border-radius: 10px;
}
.modal-card-body {
  width: 95vw;
  max-height: 95vh;
  max-width: 640px;
  padding: 12px;
  /* border-radius: 25px; */
  /* background-color: #f5d252; */
  background-color: ivory;
}
.qr-code {
  max-height: calc(95vh - 160px);
  overflow: auto;
}
input {
  width: 70vw;
}
</style>